import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { PROVIDER_CALENDAR_USAGE } from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { getAuthUserId } from '../../../data/auth/authSelectors'
import { useGetCalendarsQuery } from '../calendarApi'

const availabilityWriteableCalendarStates = [
  PROVIDER_CALENDAR_USAGE.WRITE_ALL,
  PROVIDER_CALENDAR_USAGE.WRITE_AVAILABILITY,
]

export const useCalendarConfiguration = () => {
  const userId = useSelector(getAuthUserId)
  const { data } = useGetCalendarsQuery({ providerId: userId }, { refetchOnMountOrArgChange: true })

  const validCalendars = useMemo(() => {
    return data?.filter(
      (calendar) =>
        availabilityWriteableCalendarStates.includes(calendar.calendar_usage) && calendar.status === 'VALID',
    )
  }, [data])
  return validCalendars?.length ? validCalendars[0] : null
}
